
import { Link } from 'react-router-dom';

const HeroSection = () => {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-slate-900 via-indigo-950 to-slate-900">
        <div className="absolute inset-0 opacity-30">
          <div className="absolute top-10 sm:top-20 left-10 sm:left-20 w-32 sm:w-96 h-32 sm:h-96 bg-violet-600 rounded-full mix-blend-multiply filter blur-3xl animate-pulse"></div>
          <div className="absolute bottom-10 sm:bottom-20 right-10 sm:right-20 w-32 sm:w-96 h-32 sm:h-96 bg-purple-600 rounded-full mix-blend-multiply filter blur-3xl animate-pulse delay-1000"></div>
          <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-32 sm:w-96 h-32 sm:h-96 bg-indigo-600 rounded-full mix-blend-multiply filter blur-3xl animate-pulse delay-500"></div>
        </div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 sm:py-32 w-full">
        <div className="text-center space-y-6 sm:space-y-8">
          <div className="inline-block px-4 sm:px-5 py-2 bg-violet-500/20 border border-violet-500/30 text-violet-300 text-xs sm:text-sm font-semibold rounded-full mb-4 backdrop-blur-sm">
            Next-Generation IT Solutions
          </div>
          
          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-bold text-white leading-tight max-w-5xl mx-auto">
            Powering Smarter Businesses<br />
            <span className="bg-gradient-to-r from-violet-400 via-purple-400 to-fuchsia-400 bg-clip-text text-transparent">
              with Next-Gen IT
            </span>
          </h1>
          
          <p className="text-base sm:text-lg lg:text-xl text-gray-300 max-w-3xl mx-auto leading-relaxed px-4">
            From helpdesk support to cloud migration, AZZ MATRIX delivers comprehensive IT services that keep your business running smoothly and securely.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 pt-6 justify-center px-4">
            <Link 
              to="/contact"
              className="w-full sm:w-auto px-6 sm:px-8 py-4 bg-gradient-to-r from-violet-600 to-purple-600 text-white font-semibold rounded-lg hover:from-violet-700 hover:to-purple-700 transition-all shadow-lg hover:shadow-violet-500/50 whitespace-nowrap cursor-pointer text-center"
            >
              Get Started Today
            </Link>
            <Link 
              to="/services"
              className="w-full sm:w-auto px-6 sm:px-8 py-4 border-2 border-violet-500 text-violet-300 font-semibold rounded-lg hover:bg-violet-500/10 transition-all whitespace-nowrap cursor-pointer text-center"
            >
              Explore Services
            </Link>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 sm:gap-8 pt-12 sm:pt-16 max-w-4xl mx-auto px-4">
            <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-xl p-4 sm:p-6 hover:bg-white/10 transition-all">
              <div className="text-2xl sm:text-4xl font-bold bg-gradient-to-r from-violet-400 to-purple-400 bg-clip-text text-transparent mb-2">7</div>
              <div className="text-gray-300 font-medium text-sm sm:text-base">IT Services</div>
            </div>
            <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-xl p-4 sm:p-6 hover:bg-white/10 transition-all">
              <div className="text-2xl sm:text-4xl font-bold bg-gradient-to-r from-violet-400 to-purple-400 bg-clip-text text-transparent mb-2">300+</div>
              <div className="text-gray-300 font-medium text-sm sm:text-base">Happy Clients</div>
            </div>
            <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-xl p-4 sm:p-6 hover:bg-white/10 transition-all">
              <div className="text-2xl sm:text-4xl font-bold bg-gradient-to-r from-violet-400 to-purple-400 bg-clip-text text-transparent mb-2">99.9%</div>
              <div className="text-gray-300 font-medium text-sm sm:text-base">Uptime SLA</div>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-4 sm:bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-violet-400 text-2xl sm:text-3xl"></i>
      </div>
    </section>
  );
};

export default HeroSection;
